import { utcToZonedTime } from 'date-fns-tz';

/**
 * Desliga as correcoes automaticas do teclado. Use em campos de login, senha e
 * username: no celular o teclado sobe com a primeira letra em maiuscula por
 * padrao, o que faz o usuario digitar uma senha diferente da que cadastrou.
 *
 * Vai em `inputProps` (i minusculo) do TextField, que e o que chega no <input>.
 */
export const noAutoFormat = {
    autoCapitalize: 'none',
    autoCorrect: 'off',
    spellCheck: false,
};

/**
 * Buffer do e-mail em recuperacao de senha.
 *
 * Guarda para qual conta o codigo foi pedido, para que o reenvio use esse
 * endereco em vez de um campo editavel — assim o usuario nao consegue
 * redirecionar o codigo para o e-mail de outra pessoa.
 *
 * localStorage e nao sessionStorage porque o link do e-mail costuma abrir em
 * uma aba nova, onde o sessionStorage chegaria vazio.
 */
const RESET_EMAIL_KEY = 'passwordResetEmail';

export const setResetEmail = email => {
    if (email) localStorage.setItem(RESET_EMAIL_KEY, email);
};

export const getResetEmail = () => localStorage.getItem(RESET_EMAIL_KEY) || '';

export const clearResetEmail = () => localStorage.removeItem(RESET_EMAIL_KEY);

export const bytesToSize = bytes => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 'n/a';
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    if (i === 0) return `${bytes} ${sizes[i]})`;
    return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
};

//DRAFT //ANALYSE //WAITING //IN_PROGRESS //FINISHED //CONCLUDED //CANCELED //DISAPPROVED //PAYMENT_FAIL
export const status = {
    DRAFT: 'RASCUNHO',
    ANALYSE: 'PARA ANÁLISE',
    WAITING: 'AGUARDANDO ACEITE',
    IN_PROGRESS: 'EM PROGRESSO',
    FINISHED: 'FINALIZADO',
    CANCELED: 'CANCELADO',
    DISAPPROVED: 'REPROVADA',
    CONCLUDED: 'CONCLUIDO',
    PAYMENT_FAIL: 'PAGAMENTO FALHOU',

    PAID: 'PAGO',
    DELIVERED: 'ENTREGUE',
    COLLECTED: 'COLETADO',
    ACCEPTED: 'COLETA ACEITA',
    PAYMENT_SET: 'PAGAMENTO CONFIGURADO',
};

export const orderStatus = {
    WAITING: 'AGUARDANDO',
    IN_PROGRESS: 'EM PROGRESSO',
    FINISHED: 'FINALIZADO',
    CONCLUDED: 'ENTREGUE',
    ORDER_CANCELED: 'CANCELADO',
};

export const saleStatus = {
    DRAFT: 'SEM PAGAMENTO',
    CLOSED: 'FECHADA',
    CANCELED: 'CANCELADO',
    CONCLUDED: 'PAGO',
    REJECTED: 'REJEITADO',
};

export const payments = {
    credit_card: 'Cartão de Crédito',
    pix: 'PIX',
    cash: 'Dinheiro',
    credit_card_installments: 'Cartão de Crédito - Parcelado',
    debit_card: 'Cartão de Débito',
};

export const toZonedTime = (date, zone) => {
    return utcToZonedTime(date || new Date(), zone || 'America/Sao_Paulo');
};
export const listHours = (day, horaInicial = 0, horaFinal = 23, intervaloMinutos = 1) => {
    const arrayDeHoras = [];

    // Usa o dia atual se 'day' não for passado
    const base = day ? new Date(day) : new Date();
    const year = base.getFullYear();
    const month = base.getMonth();
    const date = base.getDate();

    for (let hora = horaInicial; hora <= horaFinal; hora++) {
        for (let minuto = 0; minuto < 60; minuto += intervaloMinutos) {
            const horaFormatada = new Date(year, month, date, hora, minuto);
            arrayDeHoras.push(horaFormatada);
        }
    }

    return arrayDeHoras;
};

export const pluralize = (count, noun, suffix = 's') => `${noun}${count !== 1 ? suffix : ''}`;
